const TOPIC_ITEMS = [
  { name: '明星离婚', heat: '1280w', icon: 'ri-emotion-sad-line' },
  { name: '学术造假', heat: '960w', icon: 'ri-file-warning-line' },
  { name: '片场风波', heat: '850w', icon: 'ri-camera-off-line' },
  { name: '综艺黑幕', heat: '720w', icon: 'ri-tv-2-line' },
  { name: '偶像恋爱', heat: '680w', icon: 'ri-heart-2-line' },
  { name: '偷税漏税', heat: '540w', icon: 'ri-money-cny-circle-line' },
  { name: '网红翻车', heat: '490w', icon: 'ri-live-line' },
  { name: '品牌解约', heat: '380w', icon: 'ri-close-circle-line' },
  { name: '选秀内定', heat: '320w', icon: 'ri-award-line' },
];

export default function Topics() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-900">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            <i className="ri-hashtag text-primary-400 mr-2"></i>
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">当前最火的娱乐八卦话题标签，点击探索更多黑料</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
          {TOPIC_ITEMS.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 p-4 rounded-xl bg-background-800/40 border border-background-700/40 hover:border-primary-500/25 hover:bg-background-800/70 transition-all duration-200 cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10 text-accent-400 shrink-0">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <div className="text-sm font-semibold text-foreground-200 group-hover:text-primary-300 transition-colors truncate">
                  #{item.name}
                </div>
                <div className="text-xs text-foreground-600 mt-0.5">{item.heat} 热度</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}